import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  
  // Hide footer on practice and leaderboard pages
  if (location.pathname === '/practice' || location.pathname === '/leaderboard') {
    return null;
  }
  
  // Only show affiliate disclosure on pages with affiliate links
  const showAffiliateDisclosure = location.pathname === '/gear' || location.pathname === '/analytics';

  return (
    <footer className="app-footer">
      <div className="footer-content">
        {showAffiliateDisclosure && (
          <div className="footer-disclosure">
            <p className="affiliate-disclosure">
              <strong>Affiliate Disclosure:</strong> CustomTypingCoach participates in affiliate programs 
              with Amazon Associates and other keyboard manufacturers. We may earn a commission when 
              you click links and make purchases, at no additional cost to you. This helps support 
              the development and maintenance of this free application.
            </p>
          </div>
        )}
        
        <div className="footer-links">
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="footer-separator">•</span>
          <Link to="/about">About</Link>
          <span className="footer-separator">•</span>
          <a 
            href="mailto:ctypinghelp@gmail.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            Contact
          </a>
        </div>
        
        <div className="footer-copyright">
          <p>&copy; {currentYear} CustomTypingCoach. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
